import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_USERS_QUERY } from "../../graphql/Users/Users.graphql";

function OperatorSelect({
  variables,
  value,
  label,
  size,
  name,
  icon,
  onChange,
  readOnly,
  required
}) {
  const { data, loading, error } = useQuery(ALL_USERS_QUERY, { variables });

  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Control iconLeft size={size}>
        <Select.Container
          fullwidth
          color={
            error ||
            (required && (value === "" || value === "0" || value === 0))
              ? "danger"
              : ""
          }
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select
            disabled={readOnly}
            name={name}
            value={value}
            onChange={onChange}
          >
            <Select.Option value="">{label}</Select.Option>
            {!loading &&
              data.Users.map((User, i) => (
                <Select.Option key={`user-select-${i}`} value={User.RecId}>
                  {User.UserId}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left" size={size}>
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
}

OperatorSelect.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  variables: PropTypes.object,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool
};

OperatorSelect.defaultProps = {
  variables: {
    where: { Active: true },
    orderByMulti: ["LastName_ASC"]
  }
};
export default OperatorSelect;
